import React from 'react';
import { TETROMINOS } from '../tetrominos';

interface CellProps {
  type: number | string;
  ghost?: boolean;
}

const Cell: React.FC<CellProps> = ({ type, ghost = false }) => (
  <div
    className={`cell ${ghost ? 'ghost' : ''}`}
    style={{
      background: type === 0 ? 'transparent' : `rgba(${TETROMINOS[type as keyof typeof TETROMINOS].color}, ${ghost ? '0.3' : '0.8'})`,
      border: type === 0 ? '1px solid rgba(50, 50, 50, 0.1)' : 
              `2px solid rgba(${TETROMINOS[type as keyof typeof TETROMINOS].color}, 0.5)`,
    }}
  />
);

// Simple memo without custom comparison
export default React.memo(Cell);